<template>
  <div class="userInfo_warpper">
    <el-card class="box-card" style="height:100%">
      <div class="userInfo">
        <div class="imgWarpper">
          <el-image
            style="width:100%;height:100%;"
            fit="fill"
            :src="avatar || defaultUserIcon"
          >
            <div slot="error" class="image-slot top-img">
              <el-image
                style="width:100%;height:100%;"
                fit="fill"
                :src="avatar || defaultUserIcon"
              />
            </div>
          </el-image>
        </div>
        <div class="userInfo-right">
          <div class="contentWarpper">
            <div class="userInfo-top">
              <div class="username">{{ userName }}</div>
              <div>
                <el-button
                  @click="updateVideoStatus()"
                  type="text"
                  style="padding:0px"
                >
                  <span
                    >视频状态({{
                      videoCallStatus == "12501" ? "空闲中" : "连线中"
                    }})</span
                  >
                  <i class="el-icon-edit-outline"></i>
                </el-button>
              </div>
            </div>

            <div class="department">{{ userDepartmentName }}</div>
            <el-button @click="setUserInfo()" type="text" class="edit-btn">
              <span>编辑</span>
              <i class="el-icon-edit-outline"></i>
            </el-button>
          </div>
          <!-- <div class="btnWarpper">
            <div>{{ userInfo.professionalName }}</div>
          </div> -->
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { updateVideoStatus } from "@/api/doctor.js";
import { getDoctorInformation } from "@/api";
import util from "@/utils";
import config from "@/config/config.js";
export default {
  name: "",
  components: {},
  props: {
    userInfo: Object,
  },
  data() {
    return {
      defaultUserIcon: config.defaultUserIcon,
      userName: "",
      userDepartmentName: "",
      avatar: "",
      videoCallStatus: "",
    };
  },
  methods: {
    setUserInfo() {
      this.$router.push({
        path: "/index/user/auditInformation",
      });
    },
    async updateVideoStatus() {
      const res = await updateVideoStatus();
      if (res.code == 1) {
        this.getDoctorInformation();
      }
    },
    async getDoctorInformation() {
      const { code, data } = await getDoctorInformation();
      if (code === 1) {
        util.setStore("userInfo", data);
        this.videoCallStatus = data.videoCallStatus;
        if (data.videoCallStatus == "12502") {
          this.updateVideoStatus();
        }
      }
    },
  },
  created() {
    this.userName = util.getStore("username") || "";
    this.userDepartmentName = JSON.parse(
      util.getStore("userInfo")
    ).departmentName;
    this.avatar = JSON.parse(util.getStore("userInfo")).avatar;
    this.getDoctorInformation();
  },
};
</script>

<style lang="scss" scoped>
.userInfo-top {
  display: flex;
  align-items: flex-end;
}

.userInfo_warpper {
  height: 150px;
}

.userInfo_warpper .el-card {
  box-shadow: none !important;
}
.userInfo {
  display: flex;
  height: 100%;
  .top-img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 30px;
  }
  .imgWarpper {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background: pink;
    overflow: hidden;
    // object-fit:contain;
    margin-right: 30px;
  }
  .userInfo-right {
    flex: 1;
    display: flex;
    .contentWarpper {
      color: #000;
      font-size: 16px;
      // flex: 0 0 60%;
      display: flex;
      align-items: flex-start;
      margin-left: 12px;
      flex-direction: column;
      justify-content: space-around;
      .username {
        font-size: 30px;
      }
      .department {
        // color: #2f78ff;
        color: #fc701a;
      }
    }
  }

  .btnWarpper {
    font-size: 16px;
    color: #333;
    flex: 0 0 40%;
    cursor: pointer;
    margin-top: 3%;
  }
}
</style>
